
import { Component, Mixins } from 'vue-property-decorator';
import BS from '@/views/Home/mixins/bsMixin';
import { ISHADECOLOR, IOperateBtn } from '@/types/base.d';
import {
  ICharge,
  IContract,
  IPackage,
} from '@/types/org.d';
import OperateMixin from './mixin';
import Info from './components/info.vue';
import Cost from './components/cost.vue';
import Btn from './components/btn.vue';
import Consume from './components/consume.vue';
import Recharge from './components/recharge.vue';
import Data from './components/data.vue';
import rechargeModal from './components/form/recharge/index.vue';
import contractModal from './components/form/contract/index.vue';
import moduleModal from './components/form/module/index.vue';
import packageModal from './components/form/course/index.vue';
import examModal from './components/form/exam/index.vue';

@Component({
  components: {
    Info,
    Cost,
    Btn,
    Consume,
    Data,
    Recharge,
    rechargeModal,
    contractModal,
    moduleModal,
    packageModal,
    examModal,
  },
})
export default class OperateView extends Mixins(BS, OperateMixin) {
  private btns: Array<IOperateBtn> = [
    {
      title: '充值',
      icon: 'credit-card',
      name: '/org/operate/account:recharge',
      log: {
        name: '机构信息 - 充值',
        component: 'org/operte/components/form/recharge',
      },
      callback: this.handleRecharge,
    },
    {
      title: '对充',
      icon: 'credit-card-alt',
      name: '/org/operate/account:contra',
      log: {
        name: '机构信息 - 对充',
        component: 'org/operte/components/form/recharge',
      },
      callback: this.handleReserve,
    },
    {
      title: '账户明细',
      icon: 'list-alt',
      name: '/org/operate/account:page',
      log: {
        name: '机构信息 - 账户明细',
        component: 'org/operte/components/data',
      },
      callback: this.handleQueryAccount,
    },
    {
      title: '合同签约',
      icon: 'file-o',
      name: '/org/operate/contract:sign',
      log: {
        name: '机构信息 - 合同签约',
        component: 'org/operte/components/form/contract',
      },
      callback: this.handleAddContract,
    },
    {
      title: '合同记录',
      icon: 'file-text-o',
      name: '/org/operate/contract:page',
      log: {
        name: '机构信息 - 合同记录',
        component: 'org/operte/components/data',
      },
      callback: this.handleQueryContract,
    },
    {
      title: '课包分配',
      icon: 'columns',
      name: '/org/operate/course:add',
      log: {
        name: '机构信息 - 课包分配',
        component: 'org/operte/components/form/course',
      },
      callback: this.handlePackage,
    },
    {
      title: '课包记录',
      icon: 'table',
      name: '/org/operate/course:page',
      log: {
        name: '机构信息 - 课包记录',
        component: 'org/operte/components/data',
      },
      callback: this.handleQueryCourse,
    },
    {
      title: '试卷分配',
      icon: 'columns',
      name: '/org/operate/paper:add',
      log: {
        name: '机构信息 - 试卷分配',
        component: 'org/operte/components/form/exam',
      },
      callback: this.handleExam,
    },
    {
      title: '试卷记录',
      icon: 'table',
      name: '/org/operate/paper:page',
      log: {
        name: '机构信息 - 试卷记录',
        component: 'org/operte/components/data',
      },
      callback: this.handleQueryExam,
    },
    {
      title: '模块管理',
      icon: 'th',
      name: '/org/operate/modules:get',
      log: {
        name: '机构信息 - 模块管理',
        component: 'org/operte/components/form/module',
      },
      callback: this.handleModule,
    },
    {
      title: '重置密码',
      icon: 'refresh',
      name: '/org/manage:reset',
      log: {
        name: '机构信息 - 充值密码',
        component: 'org/operte/mixin',
      },
      callback: this.handleResetPwd,
    },
  ];

  private rechargeForm: ICharge = {
    money: 500,
    payType: 0,
    remark: '',
    orgPid: '',
  };

  private contractForm: IContract = {
    orgPid: '',
    startTime: '',
    endTime: '',
    remark: '',
  };

  private packageForm: IPackage = {
    orgPid: '',
    coursePid: '',
    price: 500,
    remark: '',
  };

  private shadeColors: Array<ISHADECOLOR> = [
    {
      way: '45deg',
      colorFirst: '#a1c4fd',
      colorLast: '#7DE2FC',
    },
    {
      way: '45deg',
      colorFirst: '#7DE2FC',
      colorLast: '#a1c4fd',
    },
  ];

  public $refs!: {
    btns: HTMLElement,
  };

  mounted() {
    this.initBS(this.$refs.btns, {
      scrollY: false,
      scrollX: true,
      scrollbar: false,
    });
  }
}
